<template>
  <div class="form-group">
    <label :for="idCampo" :class="{ required: campo.obrigatorioSeAtivo }">{{ campo.label }}</label>
    <b-form-select
      :id="idCampo"
      :value="value"
      :options="campo.opcoes"
      :disabled="disabled"
      class="form-control"
      @input="$emit('input', $event)"
    />
    <div v-if="erro" class="avisoDanger text-left mt-1">{{ erro }}</div>
  </div>
</template>

<script>
export default {
  name: 'CampoSelect',
  props: {
    idCampo: { type: String, required: true },
    campo: { type: Object, required: true },
    value: { default: '' },
    erro: { type: String, default: '' },
    disabled: { type: Boolean, default: false }
  }
}
</script>
